import React, { Fragment, useContext, useEffect } from 'react';
import { Container, Row, Col } from 'reactstrap';
import Cards from '../../components/cards/Cards';
import AuthContext from '../../context/auth/authContext';
import Roundabout from '../../components/roundabout/Roundabout';

const Home = () => {
  const authContext = useContext(AuthContext);

  useEffect(() => {
    authContext.loadUser();
    // eslint-disable-next-line
  }, []);

  return (
    <Fragment>
      <Container>
        <Roundabout />
      </Container>
      <Container className="my-3">
        <p className="text-muted">
          VacTrac is a demo-only civic-health record organizer showing how user-scoped
          vaccination records can be structured, protected, and reviewed. It is not
          intended for real medical record storage.
        </p>
      </Container>
      <Container>
        <Row>
          <Col lg="auto"><Cards /></Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default Home;
